


export const AppSettings = {
    debug : false,
    portal_prefix:'portal/',
}